module.exports = __webpack_public_path__ + "static/img_4622-24ebd72d6635fa8c1a6a066c02977b4a.webp";